export default [
  {
    path: '/event',
    component: () => import('@/views/Event.vue'),
    name: 'event',
    meta: {
      navName: 'event',
      sideNav: true,
      requiresAuth: true
    },
  },

  {
    path: '/event/new',
    component: () => import('@/views/Event/New.vue'),
    name: 'event-new',
    meta: {
      navName: 'event',
      sideNav: true,
      requiresAuth: true
    }
  },

  {
    path: '/event/:id',
    component: () => import('@/views/Event/Edit.vue'),
    name: 'event-edit',
    meta: {
      navName: 'event',
      sideNav: true,
      requiresAuth: true
    }
  },

  {
    path: '/event/:id/entry',
    component: () => import('@/views/Entry.vue'),
    name: 'event-entry',
    meta: {
      navName: 'event',
      sideNav: true,
      requiresAuth: true
    }
  },

  {
    path: '/event/:id/quizset',
    component: () => import('@/views/Event/Quizset.vue'),
    name: 'event-quizset',
    meta: {
      navName: 'event',
      sideNav: true,
      requiresAuth: true
    }
  }
]
